export default "__VITE_ASSET__cd525468__"